/**
 * LWI-1432 — stop the mouse wheel and two-finger trackpad scroll from
 * silently changing `<input type="number">` values.
 *
 * Browsers increment/decrement a *focused* number input when a wheel event
 * lands on it, so scrolling the page after clicking into Unit Cost (or any
 * other numeric field) edits the value with no visible cause. Unit Cost is
 * what got reported, but the behaviour is identical for all 43 number inputs
 * in the app, so this is installed once globally rather than added to each —
 * which also covers any number input added later.
 *
 * Blur rather than preventDefault: preventDefault would stop the value change
 * but also swallow the page scroll while the cursor sits over the input, so
 * the user's scroll would appear to do nothing. Blurring drops focus, the
 * value is left alone, and the page scrolls normally.
 *
 * Capture phase so the blur lands before the browser applies its default
 * increment for the same event. Passive, since we never call preventDefault.
 */

/** True when the wheel event would edit a focused number input. */
export function wheelWouldEditNumberInput(activeElement, eventTarget) {
  return (
    !!activeElement &&
    activeElement.tagName === "INPUT" &&
    activeElement.type === "number" &&
    // Only when the pointer is actually over the focused input — browsers
    // leave the value alone when the wheel lands anywhere else, and blurring
    // on every page scroll would yank focus for no reason.
    activeElement === eventTarget
  );
}

export default function blockNumberInputWheel(target = window) {
  if (!target || typeof target.addEventListener !== "function") return;

  target.addEventListener(
    "wheel",
    (event) => {
      const active = target.document?.activeElement ?? document.activeElement;
      if (wheelWouldEditNumberInput(active, event.target)) {
        active.blur();
      }
    },
    { capture: true, passive: true }
  );
}
